import React from 'react';
import { ShieldCheck, ShieldAlert, Lock } from 'lucide-react';
import { cn } from '@/lib/utils';

export const ComplianceBadge = ({ status = 'allowed', message, className }) => {
  const tone = status === 'allowed' ? 'success' : status === 'warning' ? 'warning' : 'destructive';
  const Icon = status === 'allowed' ? ShieldCheck : status === 'warning' ? ShieldAlert : Lock;
  return (
    <div className={cn('inline-flex items-center gap-2 px-2.5 py-1 rounded-md text-[11px] font-medium border',
      tone === 'success' && 'bg-success/10 text-success border-success/30',
      tone === 'warning' && 'bg-warning/10 text-warning border-warning/30',
      tone === 'destructive' && 'bg-destructive/10 text-destructive border-destructive/30',
      className,
    )}>
      <Icon className="h-3.5 w-3.5" />
      {message || (status === 'allowed' ? 'Compliance: Allowed' : status === 'warning' ? 'Compliance: Review' : 'Compliance: Blocked')}
    </div>
  );
};

export default ComplianceBadge;
